export const isRequired = fieldName => `${fieldName} skal udfyldes`;

export const mustMatch = otherFieldName => {
  return fieldName => `${fieldName} must match ${otherFieldName}`;
};

export const minLength = length => {
  return fieldName => `${fieldName} must be at least ${length} characters`;
};

export const isEmail = fieldName => {
  return fieldName => `${fieldName} skal udfyldes`;
};



// WEBPACK FOOTER //
// ./src/component/validation/error-messages.js